import * as React from "react";
import { Card } from "antd";
import { CardContent } from "../../components/antd/card/CardContent";
import { tagLinkUrlPrefixes } from "../../services/utils";
import { TagLinksTable } from "../../components/detail/tagLinksTable";
import { IpAddress, IpSet } from "../../schema/types/ipset/entity";
import { CpFormItem } from "../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../gvc/testNewForm/CpLabel";
import { CpErrorWarning } from "../gvc/testNewForm/CpErrorWarning";
import { CpLabelDirtyIndicator } from "../gvc/testNewForm/CpLabelDirtyIndicator";
import { CpTextArea } from "../gvc/testNewForm/CpTextArea";
import { FormLabel } from "../../components/antd/form/FormLabel";
import { Table } from "../../newcomponents/table/table";
import { CopyButtonWithApproval } from "../domain/create/copyButtonWithApproval";
import { CreatedColumn } from "../../newcomponents/table/columns/wellKnown/createdColumn";
import { InternalLink } from "../../newcomponents/table/components/InternalLink";
import { parseLink } from "../../utils/linkParser/linkParser";

interface Props {
  ipSet: IpSet;
}
export const Summary: React.FC<Props> = ({ ipSet }) => {
  const hasTagLinks =
    Object.entries(ipSet.tags || {}).filter(([_, value]) => tagLinkUrlPrefixes.some((p) => String(value).startsWith(p)))
      .length > 0;

  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardContent>
            <CpFormItem>
              <CpLabel name={`description`}>
                <FormLabel>Description</FormLabel>
                <CpLabelDirtyIndicator name={`description`} />
              </CpLabel>
              <CpTextArea autoSize name={`description`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`description`} />
            </CpFormItem>
            {hasTagLinks ? (
              <TagLinksTable
                tableId="ipset-info-tag-links"
                tags={Object.entries(ipSet.tags || {})
                  .filter(([_, value]) => tagLinkUrlPrefixes.some((p) => String(value).startsWith(p)))
                  .map(([key, value]) => ({ key, value }))}
                styles={{ container: { width: "100%" }, header: { marginBottom: 0 } }}
              />
            ) : null}
            {(ipSet.status?.ipAddresses?.length ?? 0) > 0 && (
              <Table<IpAddress>
                tableId="ipset-summary-ip-addresses"
                data={ipSet.status!.ipAddresses!}
                title={() => <FormLabel>IP Addresses</FormLabel>}
                styles={{ header: { marginBottom: 0 } }}
                hideSettings
                columns={[
                  {
                    id: "name",
                    label: "Name",
                    cell: ({ getValue }) => {
                      const link = getValue() as string;
                      const { name, absolute } = parseLink(link, { useInputCtx: true });
                      return <InternalLink label={name} to={`/console${absolute}`} />;
                    },
                  },
                  {
                    id: "ip",
                    label: "IP",
                    cell: ({ getValue }) => (
                      <div className="flex items-center gap-2">
                        <span>{getValue() as string}</span>
                        <CopyButtonWithApproval value={getValue() as string} />
                      </div>
                    ),
                  },
                  {
                    id: "state",
                    label: "State",
                    cell: ({ getValue }) => <span>{getValue() as string}</span>,
                  },
                  CreatedColumn<IpAddress>(),
                ]}
              />
            )}
          </CardContent>
        </Card>
      </div>
    </>
  );
};
